// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DebugToolbar-module__main--N2Mfw {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    max-height: 100vh;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/Debug/DebugToolbar.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,UAAU;IACV,iBAAiB;IACjB,aAAa;AACjB","sourcesContent":[".main {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 9;\n    max-height: 100vh;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `DebugToolbar-module__main--N2Mfw`
};
export default ___CSS_LOADER_EXPORT___;
